import { render } from "./OrganizationProfile.vue?vue&type=template&id=75f518fb"
import script from "./OrganizationProfile.vue?vue&type=script&lang=js"
export * from "./OrganizationProfile.vue?vue&type=script&lang=js"
script.render = render

export default script